"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFocusableElement = exports.getAllFocusableChildElements = exports.navigationKeys = void 0;
var react_1 = __importDefault(require("react"));
exports.navigationKeys = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "Escape",
    "Esc",
    "Enter",
    " ",
    "Tab"
];
var isFocusable = function (el) {
    return el !== undefined &&
        el !== null &&
        (el === null || el === void 0 ? void 0 : el.getAttribute("tabindex")) !== null &&
        (el === null || el === void 0 ? void 0 : el.getAttribute("tabindex")) !== "-1";
};
var getAllFocusableChildElements = function (el) {
    return Array.from((el === null || el === void 0 ? void 0 : el.querySelectorAll('button:not([tabindex="-1"]), a:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])')) || []).filter(function (node) {
        if (node) {
            var isDisabled = node.getAttribute("disabled");
            return (isDisabled === null ||
                isDisabled === undefined ||
                isDisabled === "false");
        }
        return false;
    });
};
exports.getAllFocusableChildElements = getAllFocusableChildElements;
var getFocusableElement = function (el, last) {
    if (last === void 0) { last = false; }
    if (el && !isFocusable(el)) {
        var children = exports.getAllFocusableChildElements(el);
        var child = children[last ? children.length - 1 : 0];
        if (isFocusable(child)) {
            return child;
        }
        if (isFocusable(el.parentElement)) {
            return el.parentElement;
        }
        return exports.getFocusableElement(last ? el.previousElementSibling : el.nextElementSibling);
    }
    return el;
};
exports.getFocusableElement = getFocusableElement;
var useKeyDown = function (props) {
    var _a = props || {}, onArrowDown = _a.onArrowDown, onArrowLeft = _a.onArrowLeft, onArrowRight = _a.onArrowRight, onArrowUp = _a.onArrowUp, handleKeyDown = _a.onKeyDown, onSelect = _a.onSelect, ref = _a.ref;
    var _b = __read(react_1.default.useState(0), 2), focused = _b[0], setFocused = _b[1];
    var onKeyDown = react_1.default.useCallback(function (e) {
        var _a, _b, _c, _d;
        handleKeyDown === null || handleKeyDown === void 0 ? void 0 : handleKeyDown(e);
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            var focusableElements = exports.getAllFocusableChildElements(ref === null || ref === void 0 ? void 0 : ref.current);
            if (focusableElements.length === 0 && isFocusable(ref === null || ref === void 0 ? void 0 : ref.current)) {
                focusableElements.push(ref === null || ref === void 0 ? void 0 : ref.current);
            }
            var length_1 = focusableElements.length;
            var newFocused = focusableElements.findIndex(function (node) { return node === document.activeElement; });
            if (newFocused !== -1) {
                switch (e.key) {
                    case "Enter":
                    case " ":
                        if (onSelect) {
                            return onSelect === null || onSelect === void 0 ? void 0 : onSelect(e);
                        }
                        (_a = focusableElements[newFocused]) === null || _a === void 0 ? void 0 : _a.click();
                        break;
                    case "ArrowDown":
                        if (onArrowDown) {
                            return onArrowDown(e);
                        }
                        newFocused += 1;
                        break;
                    case "ArrowRight":
                        if (onArrowRight) {
                            return onArrowRight(e);
                        }
                        newFocused += 1;
                        break;
                    case "ArrowUp":
                        if (onArrowUp) {
                            return onArrowUp(e);
                        }
                        newFocused -= 1;
                        break;
                    case "ArrowLeft":
                        if (onArrowLeft) {
                            return onArrowLeft(e);
                        }
                        newFocused -= 1;
                        break;
                    case "Tab":
                        if (e.shiftKey) {
                            newFocused = -1;
                        }
                        else {
                            newFocused = length_1;
                        }
                        break;
                    default:
                        break;
                }
                if (newFocused === -1) {
                    (_b = exports.getFocusableElement(ref.current.previousElementSibling, true)) === null || _b === void 0 ? void 0 : _b.focus();
                }
                else if (newFocused === length_1) {
                    (_c = exports.getFocusableElement(ref.current.nextElementSibling)) === null || _c === void 0 ? void 0 : _c.focus();
                }
                else {
                    (_d = focusableElements[newFocused]) === null || _d === void 0 ? void 0 : _d.focus();
                    setFocused(newFocused);
                }
            }
        }
        return undefined;
    }, [
        focused,
        onArrowDown,
        onArrowLeft,
        onArrowRight,
        onArrowUp,
        handleKeyDown,
        onSelect,
        ref === null || ref === void 0 ? void 0 : ref.current
    ]);
    return { onKeyDown: onKeyDown, tabIndex: 0 };
};
exports.default = useKeyDown;
//# sourceMappingURL=index.js.map